export default __webpack_public_path__ + "static/media/ashreya-logo.f71e8ea3.svg";